import React, { useEffect, useState } from 'react'
import Loader from '../components/Loader';
import { list, updateCompanyData } from '../api/company';
export default function CompanyDetails() {
    const [formData, setFormData] = useState({

    });
    const [errors, setErrors] = useState({});
    const [dynamicFormData, setDynamicFormData] = useState([{
        label: "Company Name",
        field: "companyName",
        value: "",
        errorMessage: "Company Name is required",
    },
    {
        label: "Address",
        field: "address",
        value: "",
        errorMessage: "Address is required",
    },
    {
        label: "Status",
        field: "status",
        value: "",
        errorMessage: "Status is required",

    },
    {
        label: "Number of Users",
        field: "noOfUsers",
        value: "",
        errorMessage: "Number of Users is required",
    }
    ])
    const [loading, setLoading] = useState(false);
    const [companyName, setCompanyName] = useState("0");
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const [option, setOption] = useState([{
        "id": "",
        "companyName": "Please select company"
    }]);

    const handleChange = (e) => {
        const { value } = e.target;
        const selected = option.find(
            item => String(item._id ?? item.id) === String(value)
        );
        const nextItems = dynamicFormData.map(item => ({
            ...item,
            value: selected?.[item.field] ?? ""
        }));
        const nextFormData = {};
        nextItems.forEach(item => {
            nextFormData[item.field] = item.value;
        });
        setDynamicFormData(nextItems);
        setFormData(nextFormData);
        setCompanyName(value);
    }

    const getCompanyList = async () => {
        setLoading(true);
        let data = await list();
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            console.log("data", data.data.data);
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            }))
            ]);
        }
    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getCompanyList();
    }, []);



    const handleValueChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        setErrors(prev => ({
            ...prev,
            [field]: ""
        }));
    };



    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    return (
        <>
            {loading && <Loader />}
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="form-group">
                    <label htmlFor="exampleSelectGender">Company</label>
                    <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleChange}>
                        {option
                            .filter((obj) => obj._id !== "")
                            .map((obj) => (
                                <option key={obj._id} value={obj._id} >
                                    {obj?.companyName}
                                </option>
                            ))}

                    </select>
                </div>

                <div className="row">

                    {/* <div className="page-header">
                        <h3 className="page-title"> Set Default Setting </h3>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <button type="button" onClick={handleSubmit} className="btn btn-primary me-2">Save</button>
                            </ol>
                        </nav>
                    </div> */}
                </div>
                <div className='row'>
                    <div className="col-12 grid-margin">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    {dynamicFormData.map((item, index) => (
                                        <div className="col-md-4" key={index}>
                                            <div className="form-group">
                                                <label htmlFor="exampleInputUsername1">{item.label}</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    placeholder={item.label}
                                                    value={item.value ?? ""}
                                                    readOnly
                                                    onChange={(e) => handleValueChange(item.field, e.target.value)}
                                                />
                                                {errors[item.field] && <span className="text-danger">{errors[item.field]}</span>}
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
